import { fetchApi } from "../utils/fetchApi";

export function fetchVehicle({ filter = {}, options = {} }) {  
  return fetchApi({ url: 'vehicle', filter, options });
}

